/* @flow */

import type { NETGEM_API_V8_URL_DEFINITION } from '../../../../libs/netgemLibrary/v8/types/NtgVideoFeed';
import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { RequestResponseMethodDefinitionType } from '../emitter';

import { SECONDS_PER_DAY } from '../../../../helpers/dateTime/Format';
import { logError } from '../../../../helpers/debug/debug';
import { createSmartBannerTag } from '../../../../helpers/jsHelpers/metaTag';
import { fetchJsonWithErrorCheck } from '../../../../helpers/jsHelpers/xhr';
import { createCustomNetworkErrorFromKey } from '../../../../libs/netgemLibrary/helpers/CreateCustomNetworkError';
import { updateConfiguration } from '../../../appConf/actions';
import { generateApiUrl } from '../helpers/api';

const sendV8AppConfigurationRequest: (overriddenUrl: string) => RequestResponseMethodDefinitionType =
  (overriddenUrl) =>
  async (dispatch: Dispatch, getState: () => CombinedReducers): Promise<boolean> => {
    const state = getState();
    const uri = overriddenUrl || (process.env.REACT_APP_CONFIGURATION_URL ?? '');

    if (uri === '') {
      return Promise.reject(createCustomNetworkErrorFromKey('common.messages.errors.missing_url_definition', { urlDef: 'appConfigurationUrl' }));
    }

    const appConfigurationUrl: NETGEM_API_V8_URL_DEFINITION = {
      authent: false,
      params: [
        {
          name: 'date',
          value: {
            args: [SECONDS_PER_DAY],
            op: 'now',
          },
        },
        {
          name: 'lang',
          value: {
            args: [],
            op: 'lang',
          },
        },
      ],
      uri,
    };

    const builtUri = generateApiUrl(appConfigurationUrl, {}, state);

    try {
      const { didomi, locales, ...configuration } = await fetchJsonWithErrorCheck(builtUri);

      const { appStoreAppId, htmlLoginUrl } = configuration;

      // Special HTML app case
      if (htmlLoginUrl) {
        configuration.loginUrl = htmlLoginUrl;
      }

      if (appStoreAppId) {
        // Put AppStore app Id into a smart banner tag
        createSmartBannerTag(appStoreAppId);
      }

      dispatch(updateConfiguration(configuration, didomi, locales));
      return true;
    } catch (error) {
      if (error instanceof SyntaxError) {
        logError('Error parsing AppConf');
      }
      logError(error);
      return false;
    }
  };

export default sendV8AppConfigurationRequest;
